<span [ngClass]="{ 'user-cell--italic': addItalicClass() }" class="user-cell">{{ value() | infoDisplay | translate }}</span>
